// Alert
Vue.component('v-alert', {
    props: {
        message: String,
        type: String,
    },
    data() {
        return {
            messageText: ''
        }
    },
    computed: {
        classes() {

            let classes = [
                'alert',
                'text-left'
            ];

            if(this.type === 'success') {

                classes.push('alert-success');
                classes.push('v-success');

            } else if(this.type === 'warning') {

                classes.push('alert-warning');
                classes.push('v-warning');

            } else if(this.type === 'error') {

                classes.push('alert-danger');
                classes.push('v-error');

            }

            return classes;

        }
    },
    watch: {
        message: {
            immediate: true,
            handler(value) {

                this.messageText = value;

            }
        }
    },
    template: `
        <div :class="classes" style="white-space:pre-wrap;font-size:90%;" v-if="messageText">
          <i class="fa fa-info-circle" v-if="type=='success'"></i>
          <i class="fa fa-exclamation-triangle" v-if="type=='warning'"></i>
          <i class="fa fa-exclamation-triangle" v-if="type=='error'"></i>
          <span v-text="messageText"></span>
        </div>
    `
});

// エラー表示
Vue.component('v-error', {
    props: {
        message: String,
    },
    template: `
        <v-alert type="error" :message="message"></v-alert>
    `
});

Vue.component('v-warning', {
    props: {
        message: String,
    },
    template: `
        <v-alert type="warning" :message="message"></v-alert>
    `
});

Vue.component('v-success', {
    props: {
        message: String,
    },
    template: `
        <v-alert type="success" :message="message"></v-alert>
    `
});

Vue.component('v-loading', {
    props: ['show'],
    template: `
        <div
            class="text-center"
            style="position:fixed;width:100%;bottom:0;z-index:10000;font-weight:bold;padding:16px;font-size:15px;border-top:3px solid #009b13;background:#ceffd4;color:#00680d;"
            v-if="show">
            <img style="margin-right:8px;" src="/img/loading.gif">送信中...&nbsp;
        </div>
    `
});

Vue.component('v-payment-type', {
    props: ['value'],
    data() {
        return {
            type: 'stored' // `stored` or `new`
        }
    },
    methods: {
        onChange() {

            this.$emit('input', this.type);

        }
    },
    watch: {
        type: {
            immediate: true,
            handler(value) {

                this.type = value || 'stored';

            }
        }
    },
    template: `
        <div>
            <label>
                <input type="radio" name="credit_card_type" value="stored" v-model="type" @change="onChange"> 登録済みのクレジットカードで決済する
            </label>
            <br>
            <label>
                <input type="radio" name="credit_card_type" value="new" v-model="type" @change="onChange"> 別のクレジットカードで決済する
            </label>
        </div>
    `
});

Vue.component('v-payment-methods', {
    props: {
        value: String,
        paymentMethods: Array,
        selectable: {
            type: Boolean,
            default: true
        },
        deletable: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            paymentMethodId: ''
        }
    },
    methods: {
        onDelete(id) {

            this.$emit('payment-method-delete', id);

        }
    },
    computed: {
        hasPaymentMethods() {

            return (this.paymentMethods.length > 0);

        },
        headerColumnSpan() {

            return (this.deletable === true)
                ? 2
                : 1;

        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {

                if(this.hasPaymentMethods) {

                    this.paymentMethodId = value || _.head(this.paymentMethods).id;
                    this.$emit('input', this.paymentMethodId);

                }

            }
        },
        paymentMethodId: {
            immediate: true,
            handler() {

                this.$emit('input', this.paymentMethodId);

            }
        }
    },
    template: `
        <table class="border bg-light table">
            <thead>
                <tr class="bg-secondary text-white">
                    <td class="px-3 py-2" style="font-size:0.8rem;" :colspan="headerColumnSpan">
                        <i class="fa fa-credit-card mr-2"></i>登録済みクレジットカード
                    </td>
                </tr>
            </thead>
            <tbody>
            <tr v-for="paymentMethod in paymentMethods" v-if="hasPaymentMethods">
                <td class="w-100">
                    <label>
                        <input
                            type="radio"
                            name="payment_type"
                            :value="paymentMethod.id"
                            v-if="selectable"
                            v-model="paymentMethodId">
                        <strong v-text="paymentMethod.brand"></strong>
                        <small class="text-secondary pl-1">************<span v-text="paymentMethod.last4"></span></small>
                    </label>
                </td>
                <td class="text-nowrap" v-if="deletable">
                    <button type="button" class="btn btn-sm btn-danger float-right" style="opacity:0.9;" @click="onDelete(paymentMethod.id)">
                        <i class="fa fa-trash-alt"></i>
                    </button>
                </td>
            </tr>
            <tr v-if="!hasPaymentMethods">
                <td>
                    <small class="text-secondary">データが見つかりません。</small>
                </td>
            </tr>
            </tbody>
        </table>
    `
});

Vue.component('v-preview-input', {
    props: {
        accept: {
            type: String,
            default: 'image/jpeg,image/jpg,image/png,image/gif'
        },
        value: null,
        defaultUrl: ''
    },
    data() {
        return {
            imageData: null,
            imageUrl: ''
        }
    },
    methods: {
        onFileChange(e) {

            const files = e.target.files;

            if(files.length > 0) {

                const file = files[0];
                const reader = new FileReader();
                reader.addEventListener('load', () => {

                    this.imageData = reader.result;

                });
                reader.readAsDataURL(file);
                this.$emit('input', file);
                this.imageUrl = '';

            }

        }
    },
    computed: {
        hasImageSource() {

            return (this.imageSource)

        },
        imageSource() {

            return (this.imageData !== null)
                ? this.imageData
                : this.imageUrl;

        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {

                this.imageData = null;

                if(value instanceof File) {

                    this.imageData = value;

                }

            }
        },
        defaultUrl: {
            immediate: true,
            handler(value) {

                this.imageUrl = value;

            }
        }
    },
    template: `
        <div>
            <label class="btn btn-primary">
                <slot>画像を選ぶ</slot>
                <input type="file" class="d-none" :accept="this.accept" @change="onFileChange">
            </label>
            <div v-if="hasImageSource">
                <img :src="imageSource" class="img-fluid mt-2 mb-1">
            </div>
        </div>
    `
});

Vue.component('v-user-type-label', {
    props: {
        type: Object
    },
    computed: {
        classes() {

            const color = this.type.color;
            return ['badge', `badge-${color}`, 'px-2', 'py-1', 'mb-1'];

        }
    },
    template: `
        <span style="opacity:0.8;width:70px;" :class="classes" v-text="type.name"></span>
    `
});

Vue.component('v-expiration-range', {
    props: ['from', 'to'],
    computed: {
        hasDate() {

            return (this.from || this.to);

        },
        dateFrom() {

            if(this.from) {

                return moment(this.from).format('YYYY-MM-DD　HH:mm');

            }

            return '';

        },
        dateTo() {

            if(this.to) {

                return moment(this.to).format('YYYY-MM-DD　HH:mm');

            }

            return '';

        },
    },
    template: `
        <div>
            <span v-if="hasDate">
                <span class="text-nowrap" v-text="dateFrom"></span> ~
                <br v-if="dateFrom && dateTo">
                <span class="text-nowrap" v-text="dateTo"></span>
            </span>
            <span v-else>
                なし
            </span>
        </div>
    `
});


Vue.component('v-pagination', {
    props: ['data', 'limit'],
    data() {
        return {
            page: 1,
            defaultLimit: 5
        }
    },
    methods: {
        moveTo(page) {

            this.page = page;
            this.$emit('input', page);
            this.$emit('move');

        },
        moveToPrev() {

            let page = this.page - 1;

            if(page < 1) {

                page = 1;

            }

            this.moveTo(page);

        },
        moveToNext() {

            let page = this.page + 1;

            if(page > this.data.last_page) {

                page = this.data.last_page;

            }

            this.moveTo(page);

        },
        paginationCss(page) {

            if(parseInt(page) === parseInt(this.page)) {

                return 'active';

            }

            return '';

        }
    },
    computed: {
        allPages() {

            let pages = [];
            const lastPage = parseInt(this.data.last_page) || 1;

            for(let i = 1 ; i <= lastPage ; i++) {

                pages.push(i);

            }

            const limit = (!this.limit) ? this.defaultLimit : parseInt(this.limit);

            if(pages.length > limit) {

                const pageIndex = this.page - 1;
                const beforeHalfLimit = Math.floor(limit * 0.5);
                const beforeDiffIndex = pageIndex - beforeHalfLimit;
                const afterHalfLimit = limit - beforeHalfLimit;
                const afterDiffIndex = pageIndex + afterHalfLimit - pages.length;
                let start = (beforeDiffIndex >= 0)
                    ? beforeDiffIndex
                    : 0;

                if(afterDiffIndex > 0) {

                    start -= afterDiffIndex;

                }

                let end = start + limit;
                pages = pages.slice(start, end);

            }

            return pages;

        }
    },
    watch: {
        data: {
            immediate: true,
            handler(values) {

                this.page = parseInt(values.current_page) || 1;

            }
        }
    },
    template: `
        <div>
            <ul class="pagination">
                <li class="page-item">
                <a class="page-link" href="#" aria-label="Previous" @click.prevent="moveToPrev()">
                    <span aria-hidden="true">&laquo;</span>
                    <span class="sr-only">Previous</span>
                </a>
                </li>
                <li class="page-item" v-for="p in allPages" :class="paginationCss(p)">
                  <a class="page-link" href="#" v-text="p" @click.prevent="moveTo(p)"></a>
                </li>
                <li class="page-item">
                <a class="page-link" href="#" aria-label="Next" @click.prevent="moveToNext()">
                    <span aria-hidden="true">&raquo;</span>
                    <span class="sr-only">Next</span>
                </a>
                </li>
            </ul>
        </div>
    `
});

/* Dependencies: soundMixin */
Vue.component('v-announcement', {
    mixins: [soundMixin],
    props: {
        announcementUrl: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            required: true,
            default: '' // `user`, `shop` or `npo
        }
    },
    data() {
        return {
            summary: {}
        }
    },
    methods: {
        getSummary() {

            const url = this.summaryUrl;
            axios.get(url)
                .then(response => {

                    this.summary = response.data;

                    if(this.shouldMakeSound === true) {

                        this.makeSound();

                        const lastSoundMadeAtDt = moment().format('YYYY-MM-DD HH:mm:ss');
                        localStorage.setItem(this.soundLocalStorageKey, lastSoundMadeAtDt);

                    }

                });

        },
        getClasses(announcementRead) {

            let classes = ['dropdown-item'];

            if(!announcementRead.read) {

                classes.push('bg-light-gray');

            }

            return classes;

        },
        onIconClick() {

            axios.put(this.checkUrl)
                .then(response => {

                    this.summary.unread_count = 0;

                });

        },
        onItemClick(e) {

            e.target.classList.remove('bg-light-gray');

        }
    },
    computed: {
        hasSummary() {

            return (Object.keys(this.summary).length > 0);

        },
        shouldMakeSound() {

            let result = false;
            const createdDateTimes = this.soundAnnouncementCreatedDateTimes;

            if(createdDateTimes.length > 0) {

                const lastSoundMadeAt = localStorage.getItem(this.soundLocalStorageKey);

                if(lastSoundMadeAt === null) {

                    result = true;

                }

                const lastSoundMadeAtDt = moment(lastSoundMadeAt);

                createdDateTimes.forEach(createdAt => {

                    const createdAtDt = moment(createdAt);

                    if(createdAtDt > lastSoundMadeAtDt) {

                        result = true;

                    }

                });

            }

            return result;

        },
        soundAnnouncementCreatedDateTimes() {

            if(this.hasSummary === true) {

                return this.summary.announcement_reads
                    .filter(read => {

                        return read.announcement.with_sound === true;

                    })
                    .map(read => {

                        return read.announcement.created_at;

                    });

            }

            return [];

        },
        soundLocalStorageKey() {

            return this.type +'_sound_made_at';

        },
        summaryUrl() {

            return `${this.announcementUrl}/summary`;

        },
        checkUrl() {

            return `${this.announcementUrl}/check`;

        }
    },
    mounted() {

        if(!location.href.endsWith('login')) {

            this.getSummary();

        }

    },
    template: `
        <div class="dropdown" v-if="hasSummary">
            <a href="#"
                style="position:relative;min-width:40px;"
                class="nav-link text-secondary"
                data-toggle="dropdown"
                @click.prevent="onIconClick">
                <slot>
                    <i class="far fa-bell"></i>
                </slot>
                <span style="position:absolute;top:0;left:27px;" class="badge badge-danger" v-text="summary.unread_count" v-if="summary.unread_count"></span>
            </a>
            <div style="width:250px;font-size:1.1rem;" class="dropdown-menu dropdown-menu-right p-0" aria-labelledby="navbarDropdown">
                <a :id="'announcement-list-item-'+ r.id"
                    :href="r.detail_url"
                    :class="getClasses(r)"
                    style="overflow:hidden;text-overflow:ellipsis;border-bottom: 1px solid #ddd;"
                    v-for="r in summary.announcement_reads"
                    @click="onItemClick">
                    <small class="float-right text-muted pl-3" v-text="r.created_date"></small>
                    <small v-text="r.announcement.title"></small>
                </a>
                <a class="dropdown-item text-center text-secondary" :href="announcementUrl">
                    <small>全てのお知らせを見る</small>
                </a>
            </div>
        </div>
    `
});

Vue.component('v-required', {
    template: `
        <span class="text-danger">*</span>
    `
});

Vue.component('v-from-now', {
    props: ['dateTime'],
    data() {
        return {
            units: {
                days: 86400,
                hours: 3600,
                minutes: 60,
                seconds: 1
            },
            targetDt: null
        }
    },
    methods: {
        getSecondsDiff() {

            const now = moment();
            this.targetDt = moment(this.dateTime);
            return now.diff(this.targetDt, 'seconds');

        },
        getTimeUnitValues(seconds) {

            let secondsDiff = JSON.parse(JSON.stringify(seconds));
            let timeUnitValues = { firstUnitKey: '' };

            for(const unitKey in this.units) {

                const unitSeconds = this.units[unitKey];
                const unitValue = Math.floor(secondsDiff / unitSeconds);
                timeUnitValues[unitKey] = unitValue;
                secondsDiff -= unitValue * unitSeconds;

                if(timeUnitValues.firstUnitKey === ''&& unitValue > 0) {

                    timeUnitValues.firstUnitKey = unitKey

                }

            }

            return timeUnitValues;

        }
    },
    computed: {
        timeText() {

            const secondsDiff = this.getSecondsDiff();
            const timeUnitValues = this.getTimeUnitValues(secondsDiff);
            let timeText = '';

            if(secondsDiff < 60) {

                timeText = 'たった今';

            } else if(['minutes', 'hours'].includes(timeUnitValues.firstUnitKey)) {

                if(timeUnitValues.firstUnitKey === 'minutes') {

                    timeText = `${timeUnitValues.minutes}分`;

                } else if(timeUnitValues.firstUnitKey === 'hours') {

                    timeText = `${timeUnitValues.hours}時間`;

                }

                timeText += '前';

            } else if(timeUnitValues.days < 7) {

                timeText = this.targetDt.format('dddd HH:mm');

            } else {

                timeText = this.targetDt.format('YYYY/MM/DD');

            }

            return timeText;

        }
    },
    template: `
      <span v-text="timeText"></span>
    `
});

Vue.component('v-sms-passcode', {
    props: {
        length: {
            type: Number,
            default: 6
        }
    },
    data() {
        return {
            passcode: '',
            verifying: false
        }
    },
    methods: {
        resend() {

            this.$emit('resend');

        },
        show() {

            $('#passcode_modal')
                .modal('show')
                .on('hide.bs.modal', e => {

                    e.preventDefault();
                    e.stopPropagation();
                    return false;

                });

        },
        hide() {

            $('#passcode_modal')
                .off('hide.bs.modal')
                .modal('hide')
                .on('hide.bs.modal', e => {

                    e.preventDefault();
                    e.stopPropagation();
                    return false;

                });

        },
        clear() {

            this.passcode = '';
            this.verifying = false;
            this.focusOnInput();

        },
        focusOnInput() {

            Vue.nextTick(() => {

                this.$refs.input.focus();

            });

        },
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {

                this.passcode = value;

            }
        },
        passcode(value) {

            this.$emit('input', value);

            if(value && value.length === this.length) {

                this.verifying = true;
                this.$emit('verify', value);

            }

        }
    },
    mounted() {

        $('#passcode_modal').on('shown.bs.modal', e => {

            this.focusOnInput();

        });

    },
    template: `
        <div class="modal fade" id="passcode_modal" tabindex="-1" role="dialog" aria-labelledby="passcode_modal" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-light-gray text-dark">
                        <h5 class="modal-title" id="passcode_modal"><i class="fa fa-key mr-2"></i>SMS認証</h5>
                    </div>
                    <div class="modal-body">
                        <slot>
                            入力された携帯番号へパスコードをSMS送信しました。<br>
                            以下へ入力してください。
                        </slot>
                        <small><a href="#" @click.prevent="resend">再送信する</a></small>
                        <div class="text-center py-4 bg-light mt-2" style="font-size:1.5rem;" v-if="verifying">
                            <img src="/img/ajax-loader.gif"> 認証中 ...
                        </div>
                        <div v-else>
                            <input
                                ref="input"
                                type="tel"
                                maxlength="6"
                                class="form-control mt-2 mb-2 text-center font-weight-bold"
                                style="font-size:2.5rem;letter-spacing:0.3rem;"
                                v-model="passcode">
                        </div>
                    </div>
                    <div class="modal-body">
                        <button type="button" class="btn btn-sm btn-light" @click="hide">キャンセルする</button>
                    </div>
                </div>
            </div>
        </div>
    `
});

Vue.component('v-qrcode', {
    props: {
        text: {
            type: String,
            default: ''
        },
        filename: {
            type: String,
            default: 'qrcode.png'
        },
        length: {
            type: Number,
            default: 250
        },
        margin: {
            type: Number,
            default: 2
        },
        correctionLevel: {
            type: String,
            default: 'H'
        }
    },
    data() {
        return {
            qrText: '',
            showModal: false
        }
    },
    methods: {
        download() {

            const canvas = this.$refs.canvas;
            const filename = this.filename;

            if (canvas.msToBlob) {

                const blob = canvas.msToBlob();
                window.navigator.msSaveBlob(blob, filename);

            } else {

                const downloadLink = this.$refs.downloadLink;
                downloadLink.href = canvas.toDataURL('image/png');
                downloadLink.download = filename;
                downloadLink.click();

            }

        },
        copy(e) {

            let textarea = document.createElement('textarea');
            textarea.value = this.qrText;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'absolute';
            textarea.style.left = '-9999px';
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);

            const target = e.target;
            target.classList.remove('btn-primary');
            target.classList.add('btn-success');
            target.innerHTML = '<i class="fa fa-check mr-2"></i>完了';

            setTimeout(() => {

                target.classList.remove('btn-success');
                target.classList.add('btn-primary');
                target.innerHTML = '内容をコピー';

            }, 1000)

        },
        onInputClick() {

            this.$refs.input.select();

        },
        onMouseEnter() {

            this.showModal = true;

        },
        onMouseLeave() {

            this.showModal = false;

        }
    },
    computed: {
        containerStyles() {

            return {
                width: this.length+'px',
                height: this.length+'px',
                top: 0,
                left: 0
            };

        }
    },
    watch: {
        text: {
            immediate: true,
            handler(value) {

                this.qrText = value;

            }
        }
    },
    mounted() {

        const canvas = this.$refs.canvas;
        QRCode.toCanvas(canvas, this.qrText, {
            width: this.length,
            margin: this.margin,
            errorCorrectionLevel: this.correctionLevel
        })

    },
    template: `
        <div
            class="position-relative"
            :style="containerStyles"
            @mouseenter="onMouseEnter"
            @mouseleave="onMouseLeave">
            <canvas ref="canvas"
                class="d-block"
                style="border:3px solid #555;cursor:pointer;"
                @click="download"></canvas>
            <div
                class="position-absolute"
                style="background-color:#000;opacity:0.5;"
                :style="containerStyles"
                v-if="showModal">
            </div>
            <div
                class="position-absolute p-3"
                :style="containerStyles"
                v-if="showModal">
                <button class="btn border btn-primary btn-block font-weight-bold text-nowrap" type="button" @click="download">ダウンロード</button>
                <button class="btn border btn-primary btn-block font-weight-bold text-nowrap" type="button" @click="copy">内容をコピー</button>
            </div>
            <a ref="downloadLink"></a>
        </div>
    `
});

Vue.component('v-month-navigator', {
    props: {
        value: '',
        size: {
            default: 'md'
        }
    },
    data() {
        return {
            moment: null,
            timer: null,
            lazyTime: 1000
        }
    },
    methods: {
        moveMonth(mode) {

            if(mode === 'plus') {

                this.moment = this.moment.add(1, 'month');

            } else if(mode === 'minus') {

                this.moment.subtract(1, 'month');

            } else if(mode === 'current') {

                this.moment = moment().startOf('month');

            }

            const newMoment = this.moment.clone();
            this.$emit('input', newMoment);
            this.$emit('change', newMoment);
            this.emitLazyChange(newMoment);

        },
        emitLazyChange(moment) {

            clearTimeout(this.timer);

            this.timer = setTimeout(() => {

                this.$emit('lazy-change', moment);

            }, this.lazyTime);

        }
    },
    computed: {
        hasDateTime() {

            return (this.moment instanceof moment);

        },
        yearMonthText() {

            return (this.hasDateTime)
                ? this.moment.format('YYYY年M月')
                : '';

        },
        buttonClasses() {

            return ['btn-'+ this.size];

        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {

                this.moment = value;

            }
        }
    },
    template: `
        <span v-if="hasDateTime">
            <button type="button" class="btn btn-outline-secondary mr-3" :class="buttonClasses" @click="moveMonth('current')">今月</button>
            <div class="btn-group" role="group">
                <button type="button" class="btn btn-outline-secondary px-3" :class="buttonClasses" @click="moveMonth('minus')">&lt;</button>
                <button type="button" class="btn btn-outline-secondary" :class="buttonClasses" v-text="yearMonthText"></button>
                <button type="button" class="btn btn-outline-secondary px-3" :class="buttonClasses" @click="moveMonth('plus')">&gt;</button>
            </div>
        </span>
    `
});

Vue.component('v-copy', {
    props: {
        value: {
            type: String,
            default: ''
        },
        appendingSelector: {
            type: String,
            default: ''
        }
    },
    methods: {
        copyToClipboard(e) {

            let textarea = document.createElement('textarea');
            textarea.value = this.value;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'absolute';
            textarea.style.left = '-9999px';
            const appendingElement =  (this.appendingSelector !== '')
                ? document.querySelector(this.appendingSelector)
                : document.body;

            appendingElement.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            appendingElement.removeChild(textarea);

            const target = e.target;
            const targetOriginalInnerHtml = target.innerHTML;
            target.innerHTML = '<i class="fa fa-check"></i> 完了';
            target.classList.remove('btn-primary');
            target.classList.add('btn-success');

            setTimeout(() => {

                target.innerText = targetOriginalInnerHtml;
                target.classList.remove('btn-success');
                target.classList.add('btn-primary');

            }, 1000);

        }
    },
    template: `
        <button class="btn btn-primary" @click="copyToClipboard">
            <slot>コピー</slot>
        </button>
    `
});

// Dependency: `pointMixin`
Vue.component('v-cash-exchange-sheet', {
    mixins: [pointMixin],
    props: {
        value: {
            type: Array,
            default: []
        },
        editable: false
    },
    data(){
        return {
            cashExchanges: []
        }
    },
    methods: {
        onEdit(cashExchange) {

            this.$emit('edit', cashExchange);

        },
        onDelete(cashExchange) {

            this.$emit('delete', cashExchange);

        }
    },
    computed: {
        exchangingTotal() {

            return _.sumBy(this.cashExchanges, 'exchanging_amount');

        },
        feeTotal() {

            return _.sumBy(this.cashExchanges, 'fee_amount');

        },
        exchangedTotal() {

            return _.sumBy(this.cashExchanges, 'exchanged_amount');

        },
        lastProcessAmount() {

            return _.last(this.cashExchanges)['process_amount'] || 0;

        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {

                this.cashExchanges = value;

            }
        }
    },
    template: `
        <table class="table table-sm table-bordered table-info">
            <thead>
            <tr class="bg-info text-white">
              <th class="text-nowrap">項目</th>
              <th class="text-nowrap text-right">換金対象</th>
              <th class="text-nowrap text-right">決済手数料</th>
              <th class="text-nowrap text-right">残り換金額</th>
              <th class="text-nowrap text-right">換金された金額</th>
              <th class="text-nowrap">処理日時</th>
              <th class="text-nowrap" v-if="editable">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="cashExchange in cashExchanges">
                <td class="text-nowrap" v-text="cashExchange.cash_exchange_type.label"></td>
                <td class="text-nowrap">
                    <div
                        class="text-right"
                        v-if="cashExchange.exchanging_amount"
                        v-text="numberFormat(cashExchange.exchanging_amount, true)">
                    </div>
                </td>
                <td class="text-nowrap">
                    <div
                        class="text-right"
                        v-if="cashExchange.fee_amount"
                        v-text="numberFormat(cashExchange.fee_amount, true)">
                    </div>
                </td>
                <td class="text-nowrap">
                    <div
                        class="text-right"
                        v-text="numberFormat(cashExchange.process_amount, true)">
                    </div>
                </td>
                <td class="text-nowrap text-success font-weight-bold">
                    <div
                        class="text-right"
                        v-if="cashExchange.exchanged_amount"
                        v-text="numberFormat(cashExchange.exchanged_amount, true)">
                    </div>
                </td>
                <td class="text-nowrap" v-text="cashExchange.created_date_time"></td>
                <td class="text-nowrap" v-if="editable">
                    <div style="white-space:nowrap;" v-if="cashExchange.exchanged_amount">
                      <button type="button" class="btn btn-sm btn-primary bg-light text-primary" @click="onEdit(cashExchange)">変更</button>
                      <button type="button" class="btn btn-sm btn-outline-danger bg-light text-danger" @click="onDelete(cashExchange)">削除</button>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="text-nowrap"></td>
                <td class="text-nowrap text-right">
                    合計： <span v-text="numberFormat(exchangingTotal, true)"></span>
                </td>
                <td class="text-nowrap text-right">
                    合計： <span v-text="numberFormat(feeTotal, true)"></span>
                </td>
                <td class="text-nowrap text-right text-primary font-weight-bold">
                    残り： <span v-text="numberFormat(lastProcessAmount, true)"></span>
                </td>
                <td class="text-nowrap text-right text-success font-weight-bold">
                    合計： <span v-text="numberFormat(exchangedTotal, true)"></span>
                </td>
                <td></td>
                <td v-if="editable"></td>
            </tr>
            </tbody>
        </table>
    `
});

Vue.component('v-text-count', {
    props: {
        value: {
            type: String,
            default: ''
        },
        maxLength: {
            type: String,
            default: ''
        }
    },
    computed: {
        text() {

            return this.value.replace(/(\r\n|\n|\r)/gm, '');

        },
        leftTextLength() {

            return parseInt(this.maxLength) - this.text.length;

        },
        textClasses() {

            if(this.isTextTooLong) {

                return ['text-danger', 'font-weight-bold']

            }

            return [];

        },
        isTextTooLong() {

            return (this.leftTextLength < 0);

        }
    },
    template: `
        <span :class="textClasses">
            <span v-if="!isTextTooLong">
                あと<span v-text="leftTextLength"></span>文字
            </span>
            <span v-if="isTextTooLong">
                <i class="fa fa-exclamation-triangle" v-if="isTextTooLong"></i>
                <span v-text="Math.abs(leftTextLength)"></span> 文字超過
            </span>
        </span>
    `
});

/* Dependencies: luxon */
Vue.component('v-date-navigator', {
    props: {
        value: {
            type: Object,
            default: {}
        },
        size: {
            type: String,
            default: 'md'
        },
        theme: {
            type: String,
            default: 'outline-secondary'
        }
    },
    data() {
        return {
            dt: null,
            modalId: '',
            changingDate: ''
        }
    },
    methods: {
        moveDate(days) {

            this.dt = this.dt.plus({ days: days });
            this.$emit('input', this.dt);
            this.$emit('change', this.dt);

        },
        openDateModal() {

            this.changingDate = this.dt.toFormat('yyyy-MM-dd');
            $('#'+ this.modalId).modal('show');

        },
        closeDateModal() {

            $('#'+ this.modalId).modal('hide');

        },
        onDateChange() {

            const dt = luxon.DateTime.fromSQL(this.changingDate);

            if(dt.isValid) {

                this.dt = dt;
                this.$emit('input', this.dt);
                this.$emit('change', this.dt);

            }

            this.closeDateModal();

        }
    },
    computed: {
        reservationDateContent() {

            if(this.dt) {

                const dayOfWeek = this.dt.weekdayShort;
                const year = this.dt.toFormat('yyyy年');
                const monthDay = this.dt.toFormat('M月dd日');
                return '<small>'+ year +'</small><br>'+ monthDay +' ('+ dayOfWeek +')';

            }

            return '';

        },
        mainClasses() {

            let classes = ['btn-group'];

            if(['lg', 'sm'].includes(this.size)) {

                classes.push(`btn-group-${this.size}`);

            }

            return classes;

        },
        buttonClasses() {

            let classes = ['btn'];

            if(this.theme !== '') {

                classes.push(`btn-${this.theme}`);

            }

            return classes;

        },
        todayDate() {

            return luxon.DateTime.now().toFormat('yyyy-MM-dd');

        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {

                this.dt = value;

            }
        }
    },
    mounted() {

        this.modalId = 'modal-'+ Math.random().toString(36).slice(2);

    },
    template: `
      <div :class="mainClasses">
      <button type="button" class="px-4 py-1" :class="buttonClasses" @click="moveDate(-1)"><i class="fa fa-caret-left"></i></button>
      <button type="button" :class="buttonClasses" class="py-1" @click="openDateModal">
        <div class="text-left" v-html="reservationDateContent"></div>
      </button>
      <!-- Modal -->
      <div class="modal fade" :id="modalId" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-sm" role="document">
          <div class="modal-content">
            <div class="modal-header bg-light">
              <h5 class="modal-title" id="exampleModalLabel"><i class="fa fa-calendar-check mr-2"></i>日付を指定する</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <input type="date" :min="todayDate" class="form-control" v-model="changingDate" @change="onDateChange($event)">
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-link" data-dismiss="modal">キャンセル</button>
            </div>
          </div>
        </div>
      </div>
      <button type="button" class="px-4 py-1" :class="buttonClasses" @click="moveDate(1)"><i class="fa fa-caret-right"></i></button>
      </div>
    `
});

/* Dependencies: luxon */
Vue.component('v-reservation-slot', {
    props: {
        dt: {
            default: {}
        },
        reservationStatuses: {
            default: {}
        },
        reservationSlot: {
            default: {}
        },
        ownerConfirm: {
            type: Boolean,
            default: false
        },
        withReservationLeft: false,
        testDt: {
            type: luxon.DateTime,
            default: null
        }
    },
    data() {
        return {
            showReservationLeft: true,
        }
    },
    methods: {
        isReservationValid(dateTime) {

            if(this.reservationSlot.deleted_at ||
                (this.ownerConfirm === false && this.reservationSlot.is_valid === false)) {

                return false;

            }

            const now = (this.testDt)
                ? this.testDt
                : luxon.DateTime.now();
            const targetDt = luxon.DateTime.fromSQL(dateTime);

            if(targetDt < now) {

                return false;

            } else if(this.reservationSlot.is_type_take_out === true) { // テイクアウトの時

                const timeSteps = Number(this.reservationSlot.time_steps);
                const takeOutDt = targetDt.minus({minutes: timeSteps});

                if(takeOutDt < now) {

                    return false;

                }

            }

            if(typeof this.reservationStatuses[dateTime] !== 'undefined') {

                if(this.reservationStatuses[dateTime].has_reservation === true) {

                    return false;

                }

                return this.reservationStatuses[dateTime].has_empty;

            }

            return this.isReservationValidWithCondition(targetDt);

        },
        isReservationValidWithCondition(dt) {

            const conditions = this.conditions;

            for(let i = 0 ; i < conditions.length ; i++) {

                const condition = conditions[i];

                if(this.isReservationValidWithEveryWeekCondition(dt, condition) === true ||
                    this.isReservationValidWithEveryMonthCondition(dt, condition) === true ||
                    this.isReservationValidWithDateTimeRangeCondition(dt, condition) === true ||
                    this.isReservationValidWithNthWeekNumber(dt, condition) === true) {

                    return condition.is_toggle_valid;

                }

            }

            return true;

        },
        isReservationValidWithEveryWeekCondition(dt, condition) {

            if(condition.is_condition_every_week === true) {

                const weekday = this.getWeekDay(dt);
                const conditionWeekdays = condition
                    .parameters
                    .every_week
                    .days
                    .map(day => parseInt(day));

                return conditionWeekdays.includes(weekday);

            }

            return false;

        },
        isReservationValidWithEveryMonthCondition(dt, condition) {

            if(condition.is_condition_every_month === true) {

                const day = parseInt(dt.day);
                const conditionDays = condition
                    .parameters
                    .every_month
                    .days
                    .map(day => parseInt(day));

                return conditionDays.includes(day);

            }

            return false;

        },
        isReservationValidWithDateTimeRangeCondition(dt, condition) {

            if(condition.is_condition_date_time_range === true) {

                const startDt = luxon.DateTime.fromISO(condition.parameters.date_time_range.start +':00');
                const endDt = luxon.DateTime.fromISO(condition.parameters.date_time_range.end +':00');

                return (dt >= startDt && dt < endDt);

            }

            return false;

        },
        isReservationValidWithNthWeekNumber(dt, condition) {

            if(condition.is_condition_nth_week_number === true) {

                const nth = parseInt(condition.parameters.nth_week_number.nth);
                const weekday = parseInt(condition.parameters.nth_week_number.weekday);
                const isStartOnSunday = condition.is_start_on_sunday;
                const checkingNth = this.getWeekNumber(dt, isStartOnSunday);
                const checkingWeekday = this.getWeekDay(dt);

                return (nth === checkingNth && weekday === checkingWeekday);

            }

            return false;

        },
        getEmptyBlockCount(allTimes) {

            const firstDt = luxon.DateTime.fromSQL(allTimes[0].startDateTime);
            const firstMinutes = Number(firstDt.toFormat('mm'));

            if(firstMinutes === 0) {

                return 0;

            }

            const allHourSlotCount = 60 / Number(this.reservationSlot.time_steps);
            return allHourSlotCount - allTimes.length;

        },
        getWeekNumber(dt, isStartOnSunday = true) {

            const date = new Date(dt.toFormat('yyyy-MM-dd'));
            let monthStart = new Date(date);
            monthStart.setDate(0);
            let offset = (monthStart.getDay() + 1) % 7;

            if(isStartOnSunday === false) {

                offset -= 1;

            }

            return Math.ceil((date.getDate() + offset) / 7);

        },
        getWeekDay(dt) {

            return (dt.weekday === 7) ? 0 : dt.weekday;

        },
        getPaddedNumber(number) {

            return number.toString().padStart(2, '0');

        },
        getReservationLeft(dateTime) {

            return (typeof this.reservationStatuses[dateTime] !== 'undefined')
                ? this.reservationStatuses[dateTime].reservation_left
                : this.reservationSlot.reservation_max_count;

        },
        getTooltipContent(time) {

            if(this.hasDt) {

                const startDt = this.dt.set({
                    hours: time.hours,
                    minutes: time.minutes
                });
                const endDt = startDt.plus({ minutes: this.reservationSlot.time_steps });
                const startTime = startDt.toFormat('H:mm');
                const endTime = endDt.toFormat('H:mm');
                const typeId = time.typeId;
                let tooltipContent = (typeId === 1)
                    ? `${startTime} 〜 ${endTime} のご予約`
                    : `${startTime} 以降のテイクアウト`;

                if(this.withReservationLeft === true && this.reservationSlot.reservation_max_count > 0) {

                    let reservationLeft = this.getReservationLeft(startDt.toFormat('yyyy-MM-dd HH:mm:ss'));
                    tooltipContent += `<br>残り: ${reservationLeft}`;

                }

                return tooltipContent;

            }

            return '';

        },
        onSelect(e, startDateTime, endDateTime) {

            $(e.target).tooltip('hide');
            const reservationLeft = this.getReservationLeft(startDateTime);

            this.$emit('select', {
                reservationLeft,
                startDateTime,
                endDateTime,
            });

        }
    },
    computed: {
        hasDt() {

            return (Object.keys(this.dt).length > 0);

        },
        hasReservationSlot() {

            return (Object.keys(this.reservationSlot).length > 0);

        },
        conditions() {

            return this.reservationSlot.conditions || [];

        },
        allTimes() {

            let allTimes = [];

            if(this.hasDt && this.hasReservationSlot) {

                const openTime = this.reservationSlot.open_time;
                const closeTime = this.reservationSlot.close_time;
                const timeSteps = parseInt(this.reservationSlot.time_steps);
                const date = this.dt.toFormat('yyyy-MM-dd');
                let openTimeDt = luxon.DateTime.fromFormat(date +' '+ openTime, 'yyyy-MM-dd HH:mm');
                let closeTimeDt = luxon.DateTime.fromFormat(date +' '+ closeTime, 'yyyy-MM-dd HH:mm');

                if(this.reservationSlot.is_type_take_out === true) { // テイクアウトの時

                    openTimeDt = openTimeDt.plus({ minutes: timeSteps });
                    closeTimeDt = closeTimeDt.plus({ minutes: timeSteps });

                }

                if(openTimeDt >= closeTimeDt) {

                    closeTimeDt = closeTimeDt.plus({ days: 1 });

                }

                const diffMinutes = closeTimeDt.diff(openTimeDt, ['minutes']).minutes;
                const loopCount = diffMinutes / timeSteps;

                for(let i = 0 ; i < loopCount ; i++) {

                    const time = openTimeDt.toFormat('HH:mm');
                    const hours = parseInt(openTimeDt.hour);
                    const minutes = parseInt(openTimeDt.minute);
                    const startDateTime = openTimeDt.toFormat('yyyy-MM-dd HH:mm:00');
                    const endDateTime = openTimeDt.plus({ minutes: timeSteps }).toFormat('yyyy-MM-dd HH:mm:00');
                    const typeId = Number(this.reservationSlot.type_id);
                    allTimes.push({
                        time,
                        hours,
                        minutes,
                        startDateTime,
                        endDateTime,
                        typeId
                    });
                    openTimeDt = openTimeDt.plus({ minutes: timeSteps });

                    if(!this.dt.hasSame(openTimeDt, 'day')) {

                        openTimeDt = openTimeDt.minus({ days: 1 });

                    }

                }

            }

            return allTimes;

        },
        groupedAllTimes() {

            return _.chain(this.allTimes)
                .groupBy(time => time.hours)
                .value();

        },
        reservationLeftStyles() {

            return {
                zIndex: 100,
                right: '1px',
                top: '-2px',
                backgroundColor: '#d21825',
                color: '#f9f9f9',
                fontSize: '0.5rem',
                padding: '0 5px',
                maxWidth: '18px',
            }

        }
    },
    watch: {
        dt: {
            immediate: true,
            handler() {

                Vue.nextTick(() => {

                    $('.v-reservation-slot [data-toggle="tooltip"]').tooltip({
                        placement: 'right'
                    });

                });

            }
        }
    },
    template: `
        <div class="v-reservation-slot">
            <div class="mb-3">
              <label>
                <input type="checkbox" v-model="showReservationLeft"> <small>残り件数を表示する</small>
              </label>
            </div>
            <div v-for="(allTimes,hours) in groupedAllTimes">
                <div class="row">
                    <div class="col-auto pr-2 py-2">
                      <small><span v-text="getPaddedNumber(hours)"></span>時</small>
                    </div>
                    <div v-for="i in getEmptyBlockCount(allTimes)" style="width:51px;"></div>
                    <div class="position-relative" :key="time.dateTime" v-for="time in allTimes">
                        <button
                            class="btn btn-info mx-1 mb-3 shadow-sm"
                            data-toggle="tooltip"
                            data-html="true"
                            :data-original-title="getTooltipContent(time)"
                            :disabled="!isReservationValid(time.startDateTime)"
                            v-text="getPaddedNumber(time.minutes)"
                            @click="onSelect($event, time.startDateTime, time.endDateTime)">
                        </button>
                        <div
                            class="position-absolute rounded-circle d-flex justify-content-center align-items-center"
                            :style="reservationLeftStyles"
                            v-if="showReservationLeft === true && getReservationLeft(time.startDateTime) > 0 && isReservationValid(time.startDateTime)"
                            v-text="getReservationLeft(time.startDateTime)"></div>
                    </div>
                </div>
            </div>
        </div>
    `
});

Vue.component('v-toggle-button', {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        themes: {
            true: 'success',
            false: 'light'
        },
        size: {
            type: String,
            default: 'md'
        }
    },
    methods: {
        onClick() {

            this.$emit('click', {
                value: this.value
            });

        }
    },
    computed: {
        classNames() {

            let classNames = ['btn', `btn-${this.size}`];

            if(this.value === true) {

                const trueButtonTheme = this.themes['true'];
                classNames.push(`btn-${trueButtonTheme}`);

            } else {

                const falseButtonTheme = this.themes['false'];
                classNames.push(`btn-${falseButtonTheme}`);

            }

            return classNames;

        }
    },
    template: `
        <button type="button" :class="classNames" @click="onClick">
            <slot name="true" v-if="value">有効</slot>
            <slot name="false" v-else>無効</slot>
        </button>
    `
});

Vue.component('v-toggle-switch', {
    props: {
        value: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            checked: false
        }
    },
    methods: {
        onChange() {

            const newValue = !this.value;
            this.$emit('input', newValue);
            this.$emit('toggle', newValue);

            if(newValue === true) {

                this.$emit('change-true');

            } else {

                this.$emit('change-false');

            }

        }
    },
    watch: {
        value: {
            immediate: true,
            handler(newValue) {

                this.checked = newValue;

            }
        }
    },
    template: `
        <label class="switch mr-2">
            <input type="checkbox" v-model="checked" @change="onChange">
            <span class="slider round"></span>
        </label>
    `
});

Vue.component('v-auto-scroll-button', {
    props: {
        scrollTop: {
            type: Number,
            default: 0
        },
        scrollLeft: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            currentScroll: {
                top: 0,
                left: 0
            },
            threshold: 250
        }
    },
    methods: {
        move() {

            scrollTo({
                top: this.scrollTop,
                left: this.scrollLeft,
                behavior: 'smooth'
            });

        }
    },
    computed: {
        shouldShow() {

            return (
                this.currentScroll.top > this.threshold ||
                this.currentScroll.left > this.threshold
            );

        }
    },
    mounted() {

        document.addEventListener('scroll', () => {

            this.currentScroll = {
                top: window.scrollY,
                left: window.scrollX
            };

        });

    },
    template: `
        <button
          class="position-fixed btn btn-light btn-sm text-secondary p-1"
          style="bottom:10px;right:10px;font-size:0.7rem;"
          v-if="shouldShow"
          @click.prevent="move">
          <slot><i class="fa fa-chevron-circle-up"></i> トップへ</slot>
        </button>
    `,
});

Vue.component('v-qr-scan', {
    props: {
        test: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            video: null,
            canvas: null,
            context: null,
            completed: false,
            componentWidth: -1,
            testScanText: '',
        }
    },
    methods: {
        renderFrame() {

            const video = this.video;
            const canvas = this.canvas;
            const context = this.context;

            if(video.readyState === video.HAVE_ENOUGH_DATA) {

                context.drawImage(video, 0, 0, canvas.width, canvas.height);
                const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
                const qrData = jsQR(imageData.data, imageData.width, imageData.height);

                if(qrData && qrData.data !== '') {

                    this.$emit('scan', {
                        text: qrData.data
                    });

                }

            }

            requestAnimationFrame(this.renderFrame);

        },
        initializeVideo(videoParams) {

            return navigator.mediaDevices.getUserMedia(videoParams)

        },
        initializeVideoThen(stream) {

            this.video.srcObject = stream;
            this.video.play();
            this.status = 'play';

            this.$emit('ready');

        },
        onTestScan() {

            this.$emit('scan', {
                text: this.testScanText
            });

        }
    },
    computed: {
        videoParams() {

            return {
                audio: false,
                video: {
                    facingMode: {
                        exact: 'environment'
                    },
                    width: { ideal: 1080 },
                    height: { ideal: 720 }
                }
            };

        },
    },
    mounted() {

        if(this.test === true) return; // テストモードの場合は動画処理を行わない

        this.video = document.createElement('video');
        this.video.addEventListener('loadedmetadata', () => {

            const screenWidth = window.screen.width;
            const screenHeight = window.screen.height;
            const screenOrientation = (screenHeight > screenWidth) ? 'portrait' : 'landscape';
            const videoLongLength = Math.max(this.video.videoHeight, this.video.videoWidth);
            const videoShortLength = Math.min(this.video.videoHeight, this.video.videoWidth);

            this.canvas.width = this.componentWidth;
            this.canvas.height = (screenOrientation === 'portrait')
                ? Number(this.canvas.width * videoLongLength / videoShortLength)
                : Number(this.canvas.width * videoShortLength / videoLongLength);
            this.renderFrame();

        });
        this.video.setAttribute('autoplay', '');
        this.video.setAttribute('muted', '');
        this.video.setAttribute('playsinline', '');
        this.canvas = this.$refs.canvas;
        this.context = this.canvas.getContext('2d', { willReadFrequently: true });
        this.componentWidth = this.$el.offsetWidth;
        this.initializeVideo(this.videoParams)
            .then(this.initializeVideoThen)
            .catch(error => {

                this.initializeVideo({ video: true })
                    .then(this.initializeVideoThen)

            });

    },
    beforeDestroy() {

        const stream = this.video.srcObject;

        if(stream) {

            const tracks = stream.getTracks();

            tracks.forEach(track => {

                track.stop();

            });

            this.video.srcObject = null;

        }

    },
    template: `
        <div>
            <canvas ref="canvas" style="width:100%;"></canvas>
            <div v-if="test">
                In test mode.<br>
                <input type="text" v-model="testScanText">
                <button type="button" @click="onTestScan">Scan</button>
            </div>
        </div>
    `
});

Vue.component('v-clear-input', {
    props: {
        value: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'md'
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    data() {

        return {
            inputValue: ''
        }

    },
    methods: {
        onClear() {

            this.inputValue = '';
            this.$emit('input', this.inputValue);
            this.$emit('clear', this.inputValue);
            this.$refs.input.focus();

        },
        onInput() {

            this.$emit('input', this.inputValue);

        },
        onFocus() {

            this.$emit('focus', this.inputValue);

        },
        onKeypressEnter() {

            this.$emit('keypress-enter', this.inputValue);

        }
    },
    computed: {
        classNames() {

            let classNames = ['form-control'];

            if(this.size === 'lg') {

                classNames.push('form-control-lg');

            } else if(this.size === 'sm') {

                classNames.push('form-control-sm');

            }

            return classNames;

        },
        styles() {

            const topPixels = {
                sm: 2,
                md: 4,
                lg: 6
            };
            const fontSizes = {
                sm: '1rem',
                md: '1.2rem',
                lg: '1.5rem'
            };
            const topPixel = topPixels[this.size] || 0;
            const fontSize = fontSizes[this.size] || '1rem';

            return {
                fontSize: fontSize,
                position: 'absolute',
                top: `${topPixel}px`,
                right: `11px`,
                zIndex: 1000,
                opacity: 0.8
            }

        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {

                this.inputValue = value;

            }
        }
    },
    template: `
        <div style="position:relative;">
            <input
                ref="input"
                type="text"
                :class="classNames"
                :placeholder="placeholder"
                v-model="inputValue"
                @input="onInput"
                @focus="onFocus"
                @keypress.enter="onKeypressEnter">
            <div :style="styles">
                <a href="#" @click.prevent="onClear" v-if="inputValue">
                  <i class="fa fa-times-circle"></i>
                </a>
            </div>
        </div>
    `
});

Vue.component('v-point_invalid', {
    props: {
        shopName: {
            type: String,
            required: true
        },
        isPointStateEnabled: {
            type: Boolean,
            required: true
        },
        isDiscountable: {
            type: Boolean,
            required: false
        }
    },
    template: `
        <div v-if="isPointStateEnabled == false">
            <div
                class="bg-dark rounded text-white px-1 font-weight-bold"
                style="font-size:0.5rem;display:inline-block">
                <span v-text="shopName"></span>はポイントが使えません
            </div>
        </div>
    `
});
